import { render, staticRenderFns } from "./dr-button-extended-popup-menu.vue?vue&type=template&id=3d4d773c&"
import script from "./dr-button-extended-popup-menu.vue?vue&type=script&lang=js&"
export * from "./dr-button-extended-popup-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports